import { ReactNode } from "react";
export const TestScreenPath = "/test";
export function TestScreen(): ReactNode {
  throw new Error("TestScreen error");
}
